import './App.css';
// import { BookingInvoiceDownloadRoutePattern,BookinginvoiceRoutePattern,CalendarRoutePattern,ClientProfileFormsRoutePattern,ClientProfileRoutePattern,EditAppointmentRoutePattern,EditBlockOutTimePattern,EditClientRoutePattern,NewAppointmentRoutePattern,NewClientRoutePattern,SearchClientRoutePattern,SearchLocationRoutePattern,ShareBookingLinkPattern,ViewClienProfileRoutePattern,accountancyServicePage,addDescriptionForNewClinicRoutePattern,addFormsRoutePattern,addNameAndAddressRoutePattern,addNewClinicRoutePattern,afterCareAddQARoutePattern,afterCareDashboardRoutePattern,appointmentOverviewBatchNumberRoutePattern,appointmentOverviewBeforeAndAfterAddPhotosRoutePattern,appointmentOverviewBeforeAndAfterPhotosRoutePattern,appointmentOverviewNoShowRoutePattern,appointmentOverviewTakePaymentRoutePattern,appointmentPhotosRoutePattern,blockOutTimePattern,BlockoutTimeRoutePattern,businessDashboardRoutePattern,businessLocationDetailsRoutePattern,businessTreatmentDetailsRoutePattern,businessTreatmentRoutePattern,businesslocationRoutePattern,chooseLocationRoutePattern,chooseServicesRoutePattern,clientBookingPage,clientForwardConsetFormRoutePattern,clientOverViewRoutePattern,clinicCart,clinicCartSlug,clinicCartStatus,clinicContactDetailsRoutePattern,clinicFixTimeRoutePattern,clinicPhotoUploadRoutePattern,clinicQandARoutePattern,clinicWorkingHoursRoutePattern,completeAddNewClinicRoutePattern,completeClientForwardConsetFormRoutePattern,completeonBoardingRoutePattern,createNewAfterCareFormRoutePattern,createNewFormRoutePattern,createWebsite,createWebsiteRoute,downloadFinanceInvoicePage,editProfileLandingPage,financeFirstStapPage,financeOnboardingSteps,financeOnboardingStepsNewDesign,financeStepsAbortPage,financeStepsFailPage,financeStepsThankYouPage,forgotEmailLandingPage,forgotEmailUpdateLandingPage,getAcountancyLandingPageRoute,getAppointmentListRoutePattern,getAppointmentRoutePattern,getAvailabilityClientPattern,getClientFlexibleHoursPattern,getClientTimePattern,getCustomBuildThankYouRoutePattern,getDocumnetPageRoutePattern,getFacesAiAssistantRoute,getFinanceGetPaidRoute,getFinanceIdentityRoute,getFinanceInsuranceRoute,getFinanceLandingRoute,getFinanceRegistrationRoute,getFinanceTrainingCertificateRoute,getFinancetermsRoute,getFindAPrescriberLandingPageRoute,getForwardConsentFormPageRoute,getForwardConsentFormStatus,getNurseInsurancethreePricingLandingRoute,getNurseInsurancetwoPricingLandingRoute,getOnboardingAddLocationRoutePattern,getOnboardingBookingLinkPattern,getOnboardingOnlinePaymentPattern,getOnboardingTimeAddServicePattern,getPaymentPreviewRoutePattern,getPersonalWebsiteDashboardRoute,getPrescriberAboutYouRoute,getPrescriberBusinessDetailsRoute,getPrescriberPreferencesRoutePattern,getPrescriberRegistrationPage,getPrescriberRegistrationRoute,getPurchaseWebsitePackageRoutePattern,getRyftOnboardingPageRoute,getStartedRoutePattern,getThankyouPageRoute,getWebsiteBuilderPage,HairProductLinkRoutePattern,HairProductsAmendAnswersRoutePattern,HairProductsRoutePattern,indexPage,initiateFinanceLoanRequest,insuranceLandingPage,insuranceLandingPageOld,insuranceThankyouPage,isGuestAllowed,isShowSupportChatWidget,loginLandingPage,mainClientPage,manageFormsRoutePattern,noFinanceRequests,onBoardingLocationsRoutePattern,onBoardingPagesRoutePattern,productDetailsRoutePattern,registrationLandingPage,rebookAppointmentPattern,revenueDashboardLandingPage,socialMediaMarketingPage,stripeAccountancyPaymentPage,stripePaymentPage,takePaymentRoutePattern,treatmentListing,verifyEmailLandingPage,verifyForgotPasswordLandingPage,viewBlockoutTimeRoutePattern,walkInConsentRoutePattern,welcomeBack, verifiedBannerRoutePattern, HairPrescriptionProductsRoutePattern, clientAdditionalPhotos } from './Routes';
// import { Routes, BrowserRouter as Router, Route, useNavigate, useLocation } from 'react-router-dom';
import {
	clientBookingPage, clinicCart, businessDashboardRoutePattern, getAppointmentListRoutePattern, getAppointmentRoutePattern, getStartedRoutePattern, indexPage, insuranceLandingPage, mainClientPage, treatmentListing, insuranceThankyouPage, clinicCartSlug, clinicCartStatus, isGuestAllowed, createWebsiteRoute, createWebsite, socialMediaMarketingPage, stripePaymentPage, accountancyServicePage, insuranceLandingPageOld, getFacesAiAssistantRoute, CalendarRoutePattern, NewAppointmentRoutePattern, NewClientRoutePattern, SearchClientRoutePattern, ClientProfileRoutePattern, rebookAppointmentPattern, BookinginvoiceRoutePattern, SearchLocationRoutePattern, ShareBookingLinkPattern, EditClientRoutePattern, EditAppointmentRoutePattern, isShowSupportChatWidget, getPersonalWebsiteDashboardRoute, getWebsiteBuilderPage, stripeAccountancyPaymentPage, getNurseInsurancetwoPricingLandingRoute, getNurseInsurancethreePricingLandingRoute, getFinanceLandingRoute, blockOutTimePattern, getAcountancyLandingPageRoute, BookingInvoiceDownloadRoutePattern, EditBlockOutTimePattern, BlockoutTimeRoutePattern, viewBlockoutTimeRoutePattern, ViewClienProfileRoutePattern, getFindAPrescriberLandingPageRoute, ClientProfileFormsRoutePattern, appointmentOverviewBeforeAndAfterPhotosRoutePattern, appointmentOverviewBatchNumberRoutePattern, getThankyouPageRoute, getFinanceRegistrationRoute, getPrescriberRegistrationPage, getPrescriberRegistrationRoute, getPrescriberAboutYouRoute, getPrescriberBusinessDetailsRoute, getDocumnetPageRoutePattern, getPrescriberPreferencesRoutePattern, getFinanceIdentityRoute, getFinanceTrainingCertificateRoute, getFinanceInsuranceRoute, getFinanceGetPaidRoute, getFinancetermsRoute, verifiedBannerRoutePattern, getPurchaseWebsitePackageRoutePattern, getCustomBuildThankYouRoutePattern, HairProductsAmendAnswersRoutePattern, HairProductsRoutePattern, HairProductLinkRoutePattern,
	registrationLandingPage, loginLandingPage, revenueDashboardLandingPage, verifyEmailLandingPage, forgotEmailLandingPage, verifyForgotPasswordLandingPage, forgotEmailUpdateLandingPage, editProfileLandingPage, financeFirstStapPage, downloadFinanceInvoicePage, noFinanceRequests, financeOnboardingSteps, welcomeBack, financeStepsThankYouPage, financeStepsAbortPage, financeStepsFailPage, financeOnboardingStepsNewDesign, initiateFinanceLoanRequest, getForwardConsentFormPageRoute, getForwardConsentFormStatus,
	// hairCareLandingPageRouteRequest,
	HairPrescriptionProductsRoutePattern,
	clientAdditionalPhotos,
	businessSettingRoute,
	getAvailabilityClientPattern,
	getClientTimePattern,
	getClientFlexibleHoursPattern,
	getOnboardingTimeAddServicePattern,
	getOnboardingOnlinePaymentPattern,
	walkInConsentRoutePattern,
	clientOverViewRoutePattern,
	addFormsRoutePattern,
	chooseServicesRoutePattern,
	chooseLocationRoutePattern,
	getOnboardingBookingLinkPattern,
	manageFormsRoutePattern,
	createNewFormRoutePattern,
	takePaymentRoutePattern,
	getPaymentPreviewRoutePattern,
	productDetailsRoutePattern,
	appointmentPhotosRoutePattern,
	onBoardingPagesRoutePattern,
	onBoardingLocationsRoutePattern,
	completeonBoardingRoutePattern,
	afterCareDashboardRoutePattern,
	afterCareAddQARoutePattern,
	clientForwardConsetFormRoutePattern,
	completeClientForwardConsetFormRoutePattern,
	addNewClinicRoutePattern,
	addNameAndAddressRoutePattern,
	completeAddNewClinicRoutePattern,
	addDescriptionForNewClinicRoutePattern,
	clinicContactDetailsRoutePattern,
	clinicPhotoUploadRoutePattern,
	clinicWorkingHoursRoutePattern,
	clinicFixTimeRoutePattern,
	clinicQandARoutePattern,
	createNewAfterCareFormRoutePattern,
	getOnboardingAddLocationRoutePattern,
	appointmentOverviewTakePaymentRoutePattern,
	appointmentOverviewNoShowRoutePattern,
	appointmentOverviewBeforeAndAfterAddPhotosRoutePattern,
	EditWalkInConsentRoutePattern,
	clinicFirstQandARoutePattern,
	getRyftOnboardingPageRoute,
	businessTreatmentDetailsRoutePattern,
	bookingsCoreRoutePattern,
	editAftercareFormRoutePath,
	businessTransactionListRoutePattern,
	businessTransactionDetailsRoutePattern,
	editMedicalFormRoute,
	previewMedicalFormRoute,
	addBusinessTreatmentRoutePattern,
	appointmentOverviewAppTakePaymentRoutePattern,
	TreatmentCategoriesRoutePattern,
	businesslocationRoutePattern,
	businessLocationDetailsRoutePattern,
	businessTreatmentRoutePattern,
	getBusinessSettingPageRoute,
	getBusinessProfileSettingPageRoute,
	getBusinessProfileMarketingPageRoute,
	getNoclientPageRoute,
	getManageAccountPageRoute,
	getPaymentsControlPageRoute,
	getFormSettingsPageRoute,
	getSecuritySettingsPageRoute,
	comingSoon,
	getshopSettingRoute,
	getImportClient,
	getCompanyRyftOnboardingPageRoute,
	duplicateFormRoutePattern,
	businessSupport,
	getPrescriptionServicesPageRoute,
	getSMSRoute,
	getEmailRoute,
	getPrescriberListPageRoute,
	getPrescriberDetailsPageRoute,
	getCreatePrescriptionPageRoute,
	getSMSBalanceRoute,
	EditWalkinRoutePattern,
	downloadConsentFormPattern,
	ThankyouPageRoute,
	PharmacyPrefrencesRoute,
	getFacesSupportRoute,
	getYourOrdersRoute,
	getExecutiveSupportRoute,
	getTicketsRoute,
	getKnowledgeBaseRoute,
	getCategoryDetailsRoute,
	getChatRoute,
	getPrescriberLandingRoute,
	getMyStockistsPageRoute,
	getPrescriberBioPageRoute,
	productQuestionsRoute,
	productQuestionAnswerRoute,
	ClientMedicalFormRoutePattern,
	ClientForWardMedicalFormRoutePattern,
	downloadMedicalFormPdfPattern,
	getNotificationRoute,
	businessTreatmentCategoriesRoutePattern,

} from './Routes';

import { preOnboardingSelectIndustryPath, preOnboardingBusinessDetailsPath, preOnboardingBusinessPurposePath, preOnboardingBusinessSizePath } from './Routes';

import SupportChatWidget from "../src/components/support-chat-widget/SupportChatWidget";
import CheckPreonboardingStatus from './components/pre-onboarding/CheckPreonboardingStatus';
import { CheckTokenAvailableAction } from './components/redux/actions/check-token/CheckTokenAvailable';
import { Helmet } from 'react-helmet';
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import getProfileData from './components/redux/actions/profile/Profile';
import { GetUserProfileAction } from "./components/redux/actions/profile/GetUserProfile"
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { socket } from './components/socket';
import { isLiveSystem, loginWebBaseUrl, webBaseUrl } from './config';
import showToast from './components/common/CustomToast/CustomToast';
import CustomeNotiTost from './components/customeNotiTost/customeNotiTost';
import {SHOW_NEW_NOTIFICATION_DOT} from "./components/redux/constants/headerNotification/getNotificationConst"
import { GetSupportTotalUnreadCountAction } from './components/redux/actions/get-faces-support/supportTotalUnreadsCount';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

import GlobalStyle from './styles';
import DynamicTitleComponent from './title';
import './components/LandingPagebusinessHeader/LandingPagebusinessHeader.scss'
import 'bootstrap/dist/css/bootstrap.min.css'
import PageLoader from './components/common/PageLoader';
import './app.scss';
import './components/Client/no-client.scss';
import "font-awesome/css/font-awesome.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import ProductQuestions from './components/pages/product-questions/ProductQuestions';
import PrductQuestionAnswer from "./components/pages/product-question-answer/PrductQuestionAnswer"
import MedicalForm from './components/Client/MedicalForm';
import DownloadMedicalForm from './components/Client/DownloadMedicalForm'
import BusinessTreatmentcategories from './components/pages/appointment/businessTreatmentcategories/businessTreatmentcategories';
import { GetFullstoryFlag } from './components/redux/actions/fullstory/getFullstoryFlag';

// Lazy imports for React components
const BookingLink = lazy(() => import('./components/pages/booking-link-new/BookingLink'));
const InsuranceThankyou = lazy(() => import('./components/pages/insurance-thank-you/insurance-thank-you'));
const ClinicCart = lazy(() => import('./components/pages/cart/ClinicCart'));
const LandingPage = lazy(() => import('./components/pages/landing-page/LandingPage'));
const SocialMediaMarketingLanding = lazy(() => import('./components/pages/social-media-marketing/social-media-marketing'));
const StripePaymentPage = lazy(() => import('./components/pages/stripe-payment/stripe-payment'));
const AccountancyServicePage = lazy(() => import('./components/pages/accountancy-service/accountacy-service'));
const BusinessDashboard = lazy(() => import('./components/pages/business-dashboard'));
const GetStarted = lazy(() => import('./components/pages/get-started'));
const Appointment = lazy(() => import('./components/pages/appointment'));
const AppointmentListing = lazy(() => import('./components/pages/appointment-listing'));
const SuccessPage = lazy(() => import('./components/successPage/SuccessPage'));
const CreateWebsite = lazy(() => import('./components/pages/createWebsite/createWebsite'));
const FacesAiAssistant = lazy(() => import('./components/pages/faces-ai-assistant'));
const AddForm = lazy(() => import('./components/walk-in-consent-form/AddForm'));
const ChooseLocationPage = lazy(() => import('./components/walk-in-consent-form/ChooseLocationPage'));
const ChooseServices = lazy(() => import('./components/walk-in-consent-form/ChooseServices'));
const ClientOverViewPage = lazy(() => import('./components/walk-in-consent-form/ClientOverViewPage'));
const WalkInConsentPage = lazy(() => import('./components/walk-in-consent-form/WalkInConsentPage'));
const NewAppointment = lazy(() => import('./components/new-appointment/NewAppointment'));
const SearchLocation = lazy(() => import('./components/Clinic/SearchLocation'));
const RebookAppointment = lazy(() => import('./components/pages/appointment/rebook-appointment/RebookAppointment'));
const MainCalendarView = lazy(() => import('./components/pages/calendar/MainCalendarView'));
const AddClient = lazy(() => import('./components/Client/AddClient'));
const SearchClient = lazy(() => import('./components/Client/SearchClient'));
const ClientProfile = lazy(() => import('./components/Client/ClientProfile'));
const Bookinginvoice = lazy(() => import('./components/pages/booking-invoice'));
const ShareBookingLink = lazy(() => import('./components/pages/calendar/share-booking-link/ShareBookingLink'));
const ReEntryDashboard = lazy(() => import('./components/pages/createWebsite/reEntryDashboard'));
// const SupportChatWidget = lazy(() => import('../src/components/support-chat-widget/SupportChatWidget'));
const ThankyouPage = lazy(() => import('./components/pages/forward-consent-thankyou/ThankyouPage'));
const WebsiteBuilder = lazy(() => import('./components/pages/websiteBuilder'));
const AccountancyStripePaymentPage = lazy(() => import('./components/pages/stripe-payment/accountacy-stripe-payment'));
const NurseInsurancePricingTwoLanding = lazy(() => import('./components/pages/nurse-insurance-pricing-Two-landing'));
const NurseInsurancePricingThreeLanding = lazy(() => import('./components/pages/nurse-insurance-pricing-Three-landing'));
const FinanceLanding = lazy(() => import('./components/pages/finance-landing-page'));
const BlockOutTime = lazy(() => import('./components/pages/calendar/block-out-time/BlockOutTime'));
const AcountancyLandingPage = lazy(() => import('./components/pages/acountancy-landing-page'));
const DownloadInvoice = lazy(() => import('./components/pages/booking-invoice/DownloadInvoice'));
const BlockOutTimeView = lazy(() => import('./components/pages/calendar/block-out-time/view/BlockOutTimeView'));
const ViewClientProfile = lazy(() => import('./components/Client/ViewClientProfile'));
const FindAPrescriberLandingPage = lazy(() => import('./components/pages/find-A-Prescriber-landing-page'));
const ConsentFormQA = lazy(() => import('./components/walk-in-consent-form/ConsentFormQA'));
const TakePayment = lazy(() => import('./components/pages/appointment/take-payment/TakePayment'));
const NoShow = lazy(() => import('./components/pages/appointment/no-show/NoShow'));
const BeforeAndAfterPhotosTreatment = lazy(() => import('./components/pages/appointment/before-after-photos/BeforeAndAfterPhoto'));
const BeforeAfterAddPhotos = lazy(() => import('./components/pages/appointment/before-after-add-photos/BeforeAfterAddPhotos'));
const BatchNumberSelectService = lazy(() => import('./components/pages/appointment/batch-number/BatchNumberSelectService'));
const AvailableClient = lazy(() => import('./components/pages/availability-client/available-client'));
const ClientTime = lazy(() => import('./components/pages/availability-client/client-time'));
const ClinetFliexibleHours = lazy(() => import('./components/pages/availability-client/client-flexible-hours'));
const OnboardingTimeAddService = lazy(() => import('./components/pages/availability-client/onboarding-time-add-service'));
const OnboardingBookingLink = lazy(() => import('./components/pages/availability-client/onboarding-booking-link'));
const OnboardingOnlinePayment = lazy(() => import('./components/pages/availability-client/onboarding-online-payment'));
const MainManageForm = lazy(() => import('./components/manage-forms/MainMangeForm'));
const OnBoardingAddLocation = lazy(() => import('./components/onboarding-card/OnBoardingAddLocation'));
const FormsClient = lazy(() => import('./components/Client/FormsClient'));
const BatchNumber = lazy(() => import('./components/pages/appointment/batch-number/BatchNumber'));
const Authorization = lazy(() => import('./authorization'));
const RyftOnboarding = lazy(() => import('./components/pages/ryft-onboarding-page/RyftOnboarding'));
const ForwardConsentForm = lazy(() => import('./components/pages/forward-consent-form/ForwardConsentForm'));
const SuccessForwardConsentForm = lazy(() => import('./components/pages/forward-consent-form/SuccessForwardConsentForm'));
const FinanceRegistration = lazy(() => import('./components/pages/finance-registration/finance-registration'));
const PrescriberRegistration = lazy(() => import('./components/pages/prescriber-registration/PrescriberRegistration'));
const PrescriberAboutYou = lazy(() => import('./components/pages/prescriber-about-you/PrescriberAboutYou'));
const PrescriberBusinessDetails = lazy(() => import('./components/pages/prescriber-business-details/PrescriberBusinessDetails'));
const Document = lazy(() => import('./components/pages/documet/document'));
const PrescriberPreferences = lazy(() => import('./components/pages/Prescriber/prescriberPreferences'));
const VerifiedBannerScreen = lazy(() => import('./components/dashboard/verified-banner-screen/VerifiedBannerScreen'));
const FinanceTrainingCertificate = lazy(() => import('./components/pages/finance-training-certificate'));
const FinanceIdentity = lazy(() => import('./components/pages/finance-identity'));
const FinanceInsurance = lazy(() => import('./components/pages/finance-insurance/index'));
const FinanceGetPaid = lazy(() => import('./components/pages/finance-get-paid'));
const FinanceTemsAndCondition = lazy(() => import('./components/pages/finance-terms-and-condition'));
const PurchaseWebsitePackage = lazy(() => import('./components/pages/createWebsite/purchaseWebsitePackage'));
const WelcomeScreenThankYou = lazy(() => import('./components/pages/createWebsite/welcomeScreen/welcomeScreenThankYou'));
const HairProductLink = lazy(() => import('./components/pages/hair-product-link/HairProductLink'));
const HairProducts = lazy(() => import('./components/pages/hair-products/HairProducts'));
const HairPrescriptionAmendAnswers = lazy(() => import('./components/pages/hair-product-amend-answers/HairPrescriptionAmendAnswers'));
const InitiateFinanceLoanRequest = lazy(() => import('./components/payl8r/InitiateFinanceLoanRequest'));
const HairCareLandingPage = lazy(() => import('./components/pages/HairCareLandingPage/HairCareLandingPage'));
const ClientAdditionalPhotos = lazy(() => import('./components/Client/ClientAdditionalPhotos'));
const BusinessProfileSetting = lazy(() => import('./components/pages/business-profile/BusinessProfileSetting'));
const BusinessSetting = lazy(() => import('./components/businessSetting/BusinessSetting'));
const RegistrationComponent = lazy(() => import('./components/auth/registration/registration-component'));
const LoginComponent = lazy(() => import('./components/auth/login/login-component'));
const RevenueDashboardComponent = lazy(() => import('./components/auth/revenue-dashboard/revenue-dashboard'));
const VerifyEmailComponent = lazy(() => import('./components/auth/verify-email/verify-email-component'));
const ForgotEmailComponent = lazy(() => import('./components/auth/forgot-email/forgot-email-component'));
const VerifyForgotPasswordComponent = lazy(() => import('./components/auth/verify-forgot-password/verify-forgot-password-component'));
const ForgotPasswordUpdateComponent = lazy(() => import('./components/auth/forgot-password-update/forgot-password-update-component'));
const EditProfileComponent = lazy(() => import('./components/auth/edit-profile/edit-profile-component'));
const FinanceFirstStapPage = lazy(() => import('./components/auth/finance-first-stap/FinanceFirstStapPage'));
const DownloadFinanceInvoice = lazy(() => import('./components/auth/revenue-dashboard/finance-invoice/DownloadFinanceInvoice'));
const NoFinanceRequestsPage = lazy(() => import('./components/auth/revenue-dashboard/no-finance-requests/NoFinanceRequestsPage'));
const FinanceOnboardingSteps = lazy(() => import('./components/pages/finance-onboarding-steps/financeOnboardingSteps'));
const WelcomeBack = lazy(() => import('./components/auth/welcome-back/welcomeBack'));
const FinanceStepsThankYouPage = lazy(() => import('./components/financeSteps/thankyouPage'));
const FinanceStepsAbortPage = lazy(() => import('./components/financeSteps/abortPage'));
const FinanceStepsFailPage = lazy(() => import('./components/financeSteps/failPage'));
const FinanceOnboardingStepsNew = lazy(() => import('./components/pages/finance-onboarding-steps-new/financeOnboardingSteps'));
const BusinessLocation = lazy(() => import('./components/pages/appointment/businessLocation/BusinessLocation'));
const BusinessLocationDetails = lazy(() => import('./components/pages/appointment/businessLocation/businessLocationDetails/BusinessLocationDetails'));
const BusinessTreatment = lazy(() => import('./components/pages/appointment/businessTreatment/businessTreatment'));
const BusinessTreatmentDetails = lazy(() => import('./components/pages/appointment/businessTreatment/businessTreatmentDetails/BusinessTreatmentDetails'));
const TransactionList = lazy(() => import('./components/pages/appointment/transaction/TransactionList'));
const TransactionDetails = lazy(() => import('./components/pages/appointment/transaction/transactionDetails/TransactionDetails'));
const EditMedicalForm = lazy(() => import('./components/manage-forms/medical-form/EditMedicalForm'));
const PreviewMedicalForm = lazy(() => import('./components/manage-forms/medical-form/PreviewMedicalForm'));
const AppAddCardPage = lazy(() => import('./components/pages/appointment/take-payment/AppAddCardPage'));
const EditForm = lazy(() => import('./components/manage-forms/edit-form/EditForm'));
const CreateNewForm = lazy(() => import('./components/manage-forms/create-new-form/CreateNewForm'));
const PreviewPage = lazy(() => import('./components/manage-forms/edit-form/PreviewForm'));
const TakePaymentStep1 = lazy(() => import('./components/pages/appointment/payment-pages/TakePayment1'));
const PaymentPreviewPage = lazy(() => import('./components/pages/appointment/payment-pages/PaymentPreviewPage'));
const ProductDetails = lazy(() => import('./components/pages/appointment/batch-numbe-pages/ProductDetails'));
const BeforeAndAfterPhotos = lazy(() => import('./components/pages/appointment/appointment-photos-pages'));
const OnBoardingMain = lazy(() => import('./components/dashboard/onBoarding-pages'));
const LocationOnBoarding = lazy(() => import('./components/dashboard/onBoarding-pages/business-pages/Location'));
const CompleteOnBoardingProfile = lazy(() => import('./components/dashboard/onBoarding-pages/business-pages/CompleteOnBoardingProfile'));
const AfterCareDashboard = lazy(() => import('./components/pages/appointment/after-care-form/AfterCareDashboard'));
const EditAfterCareForm = lazy(() => import('./components/pages/appointment/after-care-form/AfterCareFormEdit'));
const ClientForwConsentForm = lazy(() => import('./components/client-forward-consent-form/ClientForwConsentForm'));
const ClientConsentFormPrew = lazy(() => import('./components/client-forward-consent-form/ClientConsentFormPrew'));
const AddNewClinicList = lazy(() => import('./components/add-new-clinic/AddNewClinicList'));
const AddNameAndAddr = lazy(() => import('./components/add-new-clinic/Add-name-and-address/AddNameAndAdd'));
const CompleteClinicAddress = lazy(() => import('./components/add-new-clinic/Add-name-and-address/CompleteClinicAddress'));
const AddDescription = lazy(() => import('./components/add-new-clinic/add-description/AddNewClinicDesc'));
const ClinicContactDetails = lazy(() => import('./components/add-new-clinic/clinic-contat-details/ClinicContactDetails'));
const UploadPhotoForNewClinic = lazy(() => import('./components/add-new-clinic/add-images-new-clinic/UploadPhoto'));
const ClinicTimeTypes = lazy(() => import('./components/add-new-clinic/clinic-working-hours/ClinicTimeType'));
const ClinicFixedTiminig = lazy(() => import('./components/add-new-clinic/clinic-working-hours/fixes-hours/ClinicFixedTime'));
const CreateAfterCareForm = lazy(() => import('./components/manage-forms/after-care-new-form/CreateNewAfterCareForm'));
const PrewAfterCareForm = lazy(() => import('./components/manage-forms/after-care-new-form/PreviewAftercareform'));
const EditUserAfterCareFormTemplate = lazy(() => import('./components/manage-forms/after-care-new-form/EditAfterCareFomr'));
const TreatmentCategories = lazy(() => import('./components/pages/treatment-categories/treatmentCategories'));
const Marketing = lazy(() => import('./components/pages/business-profile/Marketing/Marketing'));
const NoClient = lazy(() => import('./components/Client/NoClient'));
const ManageAccount = lazy(() => import('./components/businessSetting/manageAccount/ManageAccount'));
const PaymentsControl = lazy(() => import('./components/pages/business-profile/PaymentsControl/PaymentsControl'));
const Form = lazy(() => import('./components/pages/business-profile/SecurityandPrivacy/Form/Form'));
const Security = lazy(() => import('./components/pages/business-profile/SecurityandPrivacy/Security'));
const ComingSoon = lazy(() => import('./components/comingSoon/ComingSoon'));
const ShopSettings = lazy(() => import('./components/businessSetting/manageAccount/shopSettings/shopSettings'));
const ImportClient = lazy(() => import('./components/pages/import-client/importClient'));
const EditConsentForm = lazy(() => import('./components/manage-forms/edit-form/common-component/EditConsentForm'));
const PreviewConsentForm = lazy(() => import('./components/manage-forms/edit-form/common-component/PreviewConsentForm'));
const POSelectIndustry = lazy(() => import('./components/pre-onboarding/POSelectIndustry'));
const POBusinessDetails = lazy(() => import('./components/pre-onboarding/POBusinessDetails'));
const POBusinessPurpose = lazy(() => import('./components/pre-onboarding/POBusinessPurpose'));
const POBusinessSize = lazy(() => import('./components/pre-onboarding/POBusinessSize'));
// const CheckPreonboardingStatus = lazy(() => import('./components/pre-onboarding/CheckPreonboardingStatus'));
const RyftBusinessType = lazy(() => import('./components/pages/ryft-business-update/RyftBusinessType'));
const RyftBusinessDetails = lazy(() => import('./components/pages/ryft-business-update/RyftBusinessDetails'));
const RyftProofOfBusiness = lazy(() => import('./components/pages/ryft-business-update/RyftProofOfBusiness'));
const CompanyRyftOnboarding = lazy(() => import('./components/pages/ryft-business-update/CompanyRyftOnboarding'));
const BusinessSupport = lazy(() => import('./components/pages/business-profile/BusinessSupport/BusinessSupport'));
const PrescriptionServices = lazy(() => import('./components/pages/prescriptionServices/prescriptionServices'));
const SendTextSms = lazy(() => import('./components/pages/business-profile/Marketing/Sms/SendTextSms/SendTextSms'));
const EmailsTemplate = lazy(() => import('./components/pages/business-profile/Marketing/Emails/EmailsTemplate/EmailsTemplate'));
const PrescriberList = lazy(() => import('./components/pages/prescriptionServices/prescriberList/PrescriberList'));
const PrescriberProfileDetails = lazy(() => import('./components/pages/prescriptionServices/prescriberProfileDetails/PrescriberProfileDetails'));
const CreatePrescription = lazy(() => import('./components/pages/prescriptionServices/createPrescription/CreatePrescription'));
const ChoosePlan = lazy(() => import('./components/pages/business-profile/Marketing/Sms/choosePlan/choosePlan'));
const Purchasesmsplan = lazy(() => import('./components/pages/business-profile/Marketing/Sms/choosePlan/purchasePlan'));
const DownloadConsentForm = lazy(() => import('./components/pages/download-consent-form/DownloadConsentForm'));
const GetFacesSupport = lazy(() => import('./components/pages/getFacesSupport/GetFacesSupport'));
const YourOrders = lazy(() => import('./components/pages/getFacesSupport/yourOrders/YourOrders'));
const ExecutiveSupport = lazy(() => import('./components/pages/getFacesSupport/executiveSupport/ExecutiveSupport'));
const Tickets = lazy(() => import('./components/pages/getFacesSupport/executiveSupport/tickets/Tickets'));
const KnowledgeBase = lazy(() => import('./components/pages/getFacesSupport/facesKnowledgeBase/knowledgeBase/KnowledgeBase'));
const CategoryDetails = lazy(() => import('./components/pages/getFacesSupport/executiveSupport/categoryDetails/CategoryDetails'));
const Chat = lazy(() => import('./components/pages/getFacesSupport/chat/Chat'));
const ThankYou = lazy(() => import('./components/pages/thankyou-registration'));
const ThankyouPharmacy = lazy(() => import('./components/thank-you-page-pharmacy/ThankyouPharmacy'));
const PrescribingPrefrence = lazy(() => import('./components/thank-you-page-pharmacy/PrescribingPrefrence'));
const PrescriberLandingPage = lazy(() => import('./components/prescriber-registration/business-details/PrescriberLandingPage'));
const MyStockists = lazy(() => import('./components/pages/prescriptionServices/MyStockists/MyStockists'));
const PrescriberBio = lazy(() => import('./components/pages/prescriptionServices/PrescriberBio/PrescriberBio'));
const InsuranceComponent = lazy(() => import('./components/pages/insurance-landing/insurance-landing'));
const Notification = lazy(() => import('./components/pages/Notification/Notification'));

export function generateRandomString() {
	return uuidv4();
}

function ScrollToTop() {
	const { pathname } = useLocation();
	const [showSupportChatWidget, setShowSupportChatWidget] = useState(true)
	console.log("pathname: " + pathname)
	useEffect(() => {
		window.scrollTo(0, 0);
		if (isGuestAllowed(pathname) || !isShowSupportChatWidget(pathname) || pathname === '/chat' || Cookies.get("faces_access_token")) {
			setShowSupportChatWidget(false)
		} else {
			setShowSupportChatWidget(true)

		}
	}, [pathname, showSupportChatWidget]);

	return (showSupportChatWidget) ? <SupportChatWidget /> : null;
}

if (sessionStorage.getItem('sessionString') === null) {
	sessionStorage.setItem('sessionString', generateRandomString())
}

const currentPath = window.location.pathname;
// if guest route return from this condition;
let actualPathToCheck = currentPath;

if (actualPathToCheck.indexOf(process.env.PUBLIC_URL) === 0) {
	actualPathToCheck = actualPathToCheck.replace(process.env.PUBLIC_URL, '');
}

function App() {

	const dispatch = useDispatch();
	// const { pathname } = useLocation();
	const { profileData } = useSelector((state) => state?.GetProfileDataReducer);
	const routerParams = {};
	Cookies.get("faces_access_token");
	let session_token = Cookies.get("faces_session");

	if (process.env.PUBLIC_URL) {
		routerParams["basename"] = process.env.PUBLIC_URL;
	}
	const { UserProfileData } = useSelector(state => state?.GetUserProfileDataReducer)
	const { initCheckTokenAvailableData } = CheckTokenAvailableAction()
	const userProfileDetails = useSelector(state => state?.GetUserProfileDataReducer)
	const { getUserProfileQueryData, initGetUserProfileData } = GetUserProfileAction()
	const { preOnboardingStep } = useSelector((state) => state?.GetPreonboardingReducer);
	const { selectedSupportChatId } = useSelector((state) => state?.GetSelectedSupportChatReducer);
    const {initSupportTotalUnreadCount }=GetSupportTotalUnreadCountAction()


	const [isConnected, setIsConnected] = useState('');
	const [userProfileData, setUserProfileData] = useState(null)
	const [currentUserId, setCurrentUserId] = useState(0)

	useEffect(() => {
		if (currentUserId) {
			const onConnect = (id) => {
				console.log("connected");
				socket.emit("online", {
					id: id,
				});
			};

			const onDisconnect = (error) => {
				console.log("disconnected", error);
				socket.off("new_message");
				socket.off('notify')
			};

			socket.on('connect', onConnect(currentUserId));

			socket.on('connect_error', (err) => {
				console.error('Connection error:', err);
				socket.off('disconnect', onDisconnect(err));
			});

			// socket.on('new_message', (data) => {
			//   console.log('logoutdata', data)
			//   if (data.type == "logout_request") {
			//     initCheckTokenAvailableData({ token: data?.device }, (res) => {
			//       if (res?.success) {
			//         // dispatch(logoutProfile());
			//         Cookies.remove('faces_access_token');
			//       }
			//     }, (err) => {
			//       console.log('err', err)
			//     })
			//   }
			// })

			return () => {
				socket.off("connect", onConnect);
				socket.off("disconnect", onDisconnect);
				// socket.disconnect();
			};
		}
	}, [currentUserId]);
	// useEffect(()=>{
	//   initGetUserProfileData()
	// },[])


	// useEffect(() => {
	//   // if(profileData) {
	//   //   setUserProfileData(profileData)
	//   // }
	//   const onConnect = () => {
	//     alert('connected')
	//     socket.emit('online', {
	//       id: 316
	//     });
	//     console.log('connected');
	//     setIsConnected(true);
	//   };

	//   const onDisconnect = () => {
	//     socket.off('new_message');
	//     setIsConnected(false);
	//   };

	//   socket.on('connect', onConnect);

	//   socket.on('connect_error', (err) => {
	//     console.error('Connection error:', err);
	//     socket.off('disconnect', onDisconnect);
	//   });

	//   socket.on('new_message', (event) => {
	//     alert("new_message 111")
	//     console.log('new_message 111', event);
	//     // if (event.domain == domain && event.mode == process.env.REACT_APP_ORDER_POPUP_MODE && (event.type == "course-purchase" || event.type == "treatment-purchase")) {
	//         // toast(<NotificationPopup eventData={event?.data} />, {
	//         //   position: "bottom-left",
	//         //   autoClose: 5000,
	//         //   className: "order",
	//         //   hideProgressBar: true,
	//         //   closeOnClick: true,
	//         //   pauseOnHover: true,
	//         //   draggable: false,
	//         //   progress: undefined,
	//         //   theme: "light",
	//         // });
	//     // }
	//   });

	//   return () => {
	//     socket.off('connect', onConnect);
	//     socket.off('disconnect', onDisconnect);
	//     socket.disconnect();
	//   };
	// }, []);
	useEffect(() => {
		if (profileData) {
			setUserProfileData(profileData)
		}
	}, [profileData])

	useEffect(() => {
		if (userProfileDetails) {
			console.log('userProfileDetails', userProfileDetails);
			setCurrentUserId(userProfileDetails?.UserProfileData?.user?.usr_id)
		}
	}, [userProfileDetails]);



	// useEffect(() => {
	//   if (currentUserId) {
	//     console.log("247",currentUserId);
	//     const onConnect = (id) => {
	//       console.log("248 ========>",id);
	//       console.log("connected");
	//       socket.emit("online", {
	//         id: id,
	//       });
	//     };

	//     const onDisconnect = (error) => {
	//       console.log("disconnected1234", error);
	//       socket.off("new_message");
	//     };

	//     socket.on('connect', onConnect(currentUserId));

	//     socket.on('new_message', (data) => {
	//       console.log('logoutdata', data)
	//       if (data.type == "logout_request") {
	//         initCheckTokenAvailableData({ token: data?.device }, (res) => {
	//           if (res?.success) {
	//             // dispatch(logoutProfile());
	//             Cookies.remove('faces_access_token');
	//             window.location.reload();
	//           }
	//         }, (err) => {
	//           console.log('err1000', err)
	//         })
	//       }
	//     })

	//     // socket.on('new_message', (data) => {
	//     //   console.log('logoutdata', data)
	//     //   if (data.type == "logout_request") {
	//     //     initCheckTokenAvailableData({ token: data?.device }, (res) => {
	//     //       if (res?.success) {
	//     //         // dispatch(logoutProfile());
	//     //         Cookies.remove('faces_access_token');
	//     //       }
	//     //     }, (err) => {
	//     //       console.log('err', err)
	//     //     })
	//     //   }
	//     // })
	//     // const notify = () => {
	//     //   alert("1022")
	//     // }

	//     // socket.on('notify', notify)

	//     return () => {
	//       socket.off("connect", onConnect);
	//       socket.off("disconnect", onDisconnect);
	//       socket.off("new_message");
	//       // socket.disconnect();
	//     };
	//   }
	// }, [currentUserId]);

	
	  
	const notificationTypes = [
		"send-form-to-prescriber",
		"new_message",
		"prescriber-registration-accepted",
		"prescriber-registration-rejected",
		"prescriber-connect-request",
		"prescription-fees-paid",
		"prescription-expired",
		"prescription-request-approved",
		"prescription-request-rejected",
		"prescriber-fee-paid",
		"prescription-request-update",
		"connect-request-approve",
		"connect-request-reject", 
		"prescriber-connected",
			'consent-form-filled',
			'booking-deposit-paid',
			'client-booking-created',
			'client-finance-interested',
			"client-cancelled-appointment",
			"booking-created-from-website",
			"new_prescription_request",
			'deposit-paid' ,   
			'direct-deposit-expired',
			'booking-expired',
			'pharmacy-practitioner-prescription-request-approved',
			'pharmacy-practitioner-prescription-request-rejected',
			'pharmacy-prescriber-registration-accepted',
			'practitioner-prescriber-registration-accepted',
			'pharmacy-prescriber-registration-rejected',
			'practitioner-prescriber-registration-rejected',
			'finance-paid-by-clients',
			'admin_manual_notifications',
			'appointment-reminder',
			'finance-application-approved',
			'finance-option-reactivated', 
			'shop-order-complete',
			// "support-chat-message",
			'admin-notification'
	]; 
	useEffect(() => {
		if (currentUserId) {
			const onConnect = (id) => {
				console.log('connected');
				socket.emit('online', {
					id: id
				});
			};

			const onDisconnect = (error) => {
				console.log("disconnected456", error);
				socket.off("new_message");
				socket.off("notify")
				// socket.off("notify");
			};

			socket.on('connect', onConnect(currentUserId));

			socket.on('new_message', (data) => {
				console.log('logoutdata', data)
				console.log("wel come wel come wel come wel come wel come")
				if (data.type == "logout_request") {
					initCheckTokenAvailableData({ token: data?.device }, (res) => {
						if (res?.success) {
							// dispatch(logoutProfile());
							Cookies.remove('faces_access_token');
							window.location.reload();
						}
					}, (err) => {
						console.log('err1000', err)
					})
				}
				notify(data)
			})

			socket.on('notify' , (data) => {
				console.log('notify data', data)
                notify(data)
			})
			socket.on('connect_error', (err) => {
				console.error('Connection error:', err);
				socket.off('disconnect', onDisconnect(err));
			});
			const notify = (event) => {
				console.log(event,"eventssss")
				if (event.mode === process.env.REACT_APP_SOCKET_NOTIFICATION_MODE && (notificationTypes.includes(event.type) || (event.type ==="support-chat-message" && actualPathToCheck != "/chat"))
					&& (event.to_id === currentUserId || event.userId === currentUserId)
				) {
					// showToast("no_icon", event.title, event.message, "")
					toast(
					<CustomeNotiTost Title={event.title} Desc={event.message} clickOnCallback={() => {
						console.log("linksdfadfd", event.link)
						if(event.link){window.open(event.link, "_blank")}
					}} />, {
						position: "top-center",
						autoClose: 5000,
						className: "order",
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: false,
						progress: undefined,
						theme: "light",
					});
					dispatch({
						type:SHOW_NEW_NOTIFICATION_DOT,
						payload:true
					})
				}
				if(event.mode === process.env.REACT_APP_SOCKET_NOTIFICATION_MODE && event.type === "support-chat-message" && event.userId === currentUserId){
					initSupportTotalUnreadCount()
				}
			}

			// socket.on('notify', notify)

			return () => {
				socket.off("connect", onConnect);
				socket.off("disconnect", onDisconnect);
				socket.off("message");
				// socket.off("notify");
				// socket.disconnect();
			};
		}
	}, [currentUserId])

	  const handleNotify = (event) => {
		console.log(event,"eventssss",event?.thread_id,selectedSupportChatId)
		if (event.mode === process.env.REACT_APP_SOCKET_NOTIFICATION_MODE && (event.type === "support-chat-message" && event?.thread_id != selectedSupportChatId)
			&& (event.to_id === currentUserId || event.userId === currentUserId)
		) {
			// showToast("no_icon", event.title, event.message, "")
			toast(<CustomeNotiTost Title={event.title} Desc={event.message} clickOnCallback={() => {
				console.log("linksdfadfd", event.link)
				window.open(event.link, "_blank")
			}} />, {
				position: "top-center",
				autoClose: 5000,
				className: "order",
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: false,
				progress: undefined,
				theme: "light",
			});
			dispatch({
				type:SHOW_NEW_NOTIFICATION_DOT,
				payload:true
			})
		}
		if(event.mode === process.env.REACT_APP_SOCKET_NOTIFICATION_MODE && event.type === "support-chat-message" && event.userId === currentUserId){
			initSupportTotalUnreadCount()
		}
	}
	  useEffect(() => {
		socket.on("notify", handleNotify);
	
		return () => {
		  socket.off("notify", handleNotify);
		};
	  }, [selectedSupportChatId]);

	useEffect(() => {
		let pathnameToBeChecked = window.location.pathname;

		let cleanPathname =
			pathnameToBeChecked.indexOf(process.env.PUBLIC_URL) === 0
				? pathnameToBeChecked.replace(process.env.PUBLIC_URL, '')
				: pathnameToBeChecked;

		if (cleanPathname.indexOf(process.env.PUBLIC_URL) == 0) {
			cleanPathname = cleanPathname.replace(process.env.PUBLIC_URL, '');
		}
		if (profileData == null && !isGuestAllowed(cleanPathname))
			dispatch(getProfileData())

		if (UserProfileData == null && !isGuestAllowed(cleanPathname))
			initGetUserProfileData()

		console.log("INSURANCE_TEST is guest allowed ", cleanPathname, isGuestAllowed(cleanPathname), pathnameToBeChecked);

		if (!(Cookies.get("faces_access_token") || Cookies.get("faces_session")) && !isGuestAllowed(cleanPathname)) {
			console.log("INSURANCE_TEST - redirecting user to login from app.js, as token is not present");
			window.location.href = `${loginWebBaseUrl}/login`;

			// Cookies.set("faces_access_token","eyJpdiI6IkliaTF3bVRJWkR2Q3IwcE1sU1Z1VUE9PSIsInZhbHVlIjoicHZGejVoM1N4K3Z1cVpoUFk5UlR2RGs0M0h2R2JJdXp5YnFvRkkweEpJQzY1dDJRcERJUDJDckM4eEJBMkZGOUJyT3JoVFMzXC9KNzNnNm13dFZueFc0UzQzSVBHc3g2ZFRlVmtiV1F5ZHNZPSIsIm1hYyI6IjAxMmVlMjQwYmIxNzg0NWJjOTkzZDg2NWY4ZjJhNjUwODkwYmZhYWY2MDkxYjM3NDdhZTRlNzllMjFkYjFhZmYifQ==");
		}
	}, [window.location.pathname])
	useEffect(() => {
		socket.on('message', (event) => {
		  const { sub_title, title } = event.dataObj;
		  console.log("event.dataObj",event.dataObj, event.type)
		  if (event.type === "send-to-user"){
			  //  showToast
			  console.log(sub_title ,title)
			  showToast("success", title,sub_title  , "", false)       
		  }
		})
		const onDisconnect = (error) => {
		  console.log('disconnected', error)
		  socket.off('message')
		}
		return () => {
		  socket.off('disconnect', onDisconnect)
		}
	  }, [])
	// call api to set cookie
	const { initGetFullstoryFlag, fullstoryFlagQueryData } = GetFullstoryFlag();	
	useEffect(() => {
		const cookieName = "facesconsent-fullstory-load-v2";

		let pathnameToBeChecked = window.location.pathname;

		let cleanPathname =
			pathnameToBeChecked.indexOf(process.env.PUBLIC_URL) === 0
				? pathnameToBeChecked.replace(process.env.PUBLIC_URL, '')
				: pathnameToBeChecked;

		let type = '';
		
		if(cleanPathname.startsWith('/bookings/')){
			type = 'bookingLink';
		}else if(cleanPathname.startsWith('/forward-consent-form/')){
			type = 'forwardedConsentForm';
		}else if(Cookies.get('faces_access_token')){
			type = 'web';
		}		
	
		// Check if cookie is already set
		if (!Cookies.get(cookieName) && type !== '' && isLiveSystem) {
			initGetFullstoryFlag({ type: type });		  
		}else{
			let trackingAllowed = Cookies.get(cookieName);
			if(trackingAllowed === "yes" && type !== '' && isLiveSystem){				
				initializeFullStory();
			}
		}
	}, []);

	// Watch for changes in fullstoryFlagQueryData.data
	useEffect(() => {
		const cookieName = "facesconsent-fullstory-load-v2";

		let pathnameToBeChecked = window.location.pathname;

		let cleanPathname =
			pathnameToBeChecked.indexOf(process.env.PUBLIC_URL) === 0
				? pathnameToBeChecked.replace(process.env.PUBLIC_URL, '')
				: pathnameToBeChecked;
	
		let trackingAllowed = Cookies.get(cookieName);

		let type = '';

		if (fullstoryFlagQueryData?.data && !trackingAllowed) {
			trackingAllowed = fullstoryFlagQueryData.data?.getFullstoryFlag?.data?.tracking_allowed;

			if (trackingAllowed) {
				Cookies.set(cookieName, "yes", { expires: 1 }); // Set for 1 day
				initializeFullStory();
			} else {
				Cookies.set(cookieName, "no", { expires: 1 });
			}
		}
	}, [fullstoryFlagQueryData?.data]);

	function initializeFullStory() {
		window["_fs_host"] = "fullstory.com";
		window["_fs_script"] = "edge.fullstory.com/s/fs.js";
		window["_fs_org"] = "o-226668-na1";
		window["_fs_namespace"] = "FS";
	  
		(function (m, n, e, t, l, o, g, y) {
		  var s, f;
		  var a = function (h) {
			return !(h in m) || (m.console && m.console.log && m.console.log("FullStory namespace conflict. Please set window['_fs_namespace']."), false);
		  }(e);
	  
		  function p(b) {
			var h, d = [];
	  
			function j() {
			  if (h) {
				d.forEach(function (b) {
				  var d;
				  try {
					d = b[h[0]] && b[h[0]](h[1]);
				  } catch (h) {
					if (b[3]) b[3](h);
					return;
				  }
				  d && d.then ? d.then(b[2], b[3]) : b[2] && b[2](d);
				});
				d.length = 0;
			  }
			}
	  
			function r(b) {
			  return function (d) {
				if (!h) {
				  h = [b, d];
				  j();
				}
			  };
			}
	  
			return b(r(0), r(1)), {
			  then: function (b, h) {
				return p(function (r, i) {
				  d.push([b, h, r, i]);
				  j();
				});
			  }
			};
		  }
	  
		  if (a) {
			g = m[e] = function () {
			  function h(h, d, j, r, i, c) {
				return b._api ? b._api(h, d, j, r, i, c) : (b.q && b.q.push([h, d, j, r, i, c]), null);
			  }
	  
			  var b = function (b, d, j, r) {
				function i(i, c) {
				  h(b, d, j, i, c, r);
				}
				r = r || 2;
				var c, u = /Async$/;
				return u.test(b) ? (b = b.replace(u, ""), "function" === typeof Promise ? new Promise(i) : p(i)) : h(b, d, j, c, c, r);
			  };
			  
			  b.q = [];
			  return b;
			}();
	  
			y = function (b) {
			  var d = g.q;
			  if (d) {
				for (var j = 0; j < d.length; j++) {
				  if (typeof d[j][4] === "function") d[j][4](new Error(b));
				}
				d.length = 0;
				d.push = function () {};
			  }
			};
	  
			(function () {
			  o = n.createElement(t);
			  o.async = true;
			  o.crossOrigin = "anonymous";
			  o.src = "https://" + l;
			  o.onerror = function () {
				y("Error loading " + l);
			  };
			  var b = n.getElementsByTagName(t)[0];
			  if (b && b.parentNode) {
				b.parentNode.insertBefore(o, b);
			  } else {
				n.head.appendChild(o);
			  }
			})();
	  
			(function () {
			  function b() {}
	  
			  function h(b, h, d) {
				g(b, h, d, 1);
			  }
	  
			  function d(b, d, j) {
				h("setProperties", { type: b, properties: d }, j);
			  }
	  
			  function j(b, h) {
				d("user", b, h);
			  }
	  
			  function r(b, h, d) {
				j({ uid: b }, d);
				if (h) j(h, d);
			  }
	  
			  g.identify = r;
			  g.setUserVars = j;
			  g.identifyAccount = b;
			  g.clearUserCookie = b;
			  g.setVars = d;
			  g.event = function (b, d, j) {
				h("trackEvent", { name: b, properties: d }, j);
			  };
			  g.anonymize = function () {
				r(false);
			  };
			  g.shutdown = function () {
				h("shutdown");
			  };
			  g.restart = function () {
				h("restart");
			  };
			  g.log = function (b, d) {
				h("log", { level: b, msg: d });
			  };
			  g.consent = function (b) {
				h("setIdentity", { consent: !arguments.length || b });
			  };
			})();
	  
			s = "fetch";
			f = "XMLHttpRequest";
			g._w = {};
			g._w[f] = m[f];
			g._w[s] = m[s];
			if (m[s]) {
			  m[s] = function () {
				return g._w[s].apply(this, arguments);
			  };
			}
			g._v = "2.0.0";
		  }
		})(window, document, window._fs_namespace, "script", window._fs_script);
	}
	  

	if (preOnboardingStep === null) {
		return <CheckPreonboardingStatus />
	}

	if (preOnboardingStep < 4 && !isGuestAllowed(actualPathToCheck)) {
		return <>
			<CheckPreonboardingStatus />
			<Router {...routerParams}>
				<ScrollToTop />
				<DynamicTitleComponent />
				<Suspense fallback={<PageLoader />}>
					<Routes>
						<Route
							exact
							path={indexPage}
							element={<LandingPage />}
						/>
						<Route
							exact
							path={preOnboardingSelectIndustryPath}
							element={<POSelectIndustry />}
						/>
						<Route
							exact
							path={preOnboardingBusinessDetailsPath}
							element={<POBusinessDetails />}
						/>
						<Route
							exact
							path={preOnboardingBusinessPurposePath}
							element={<POBusinessPurpose />}
						/>
						<Route
							exact
							path={preOnboardingBusinessSizePath}
							element={<POBusinessSize />}
						/>
					</Routes>
				</Suspense>
			</Router>
			<ToastContainer
				position="top-left"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="dark"
			/>
		</>
	}

	return (
		<>
			<Helmet>
				{!isLiveSystem && <meta name="robots" content="noindex, nofollow" />}
			</Helmet>
			{/* <Suspense fallback={<>Loading...</>}> */}
				<CheckPreonboardingStatus />
			{/* </Suspense> */}
			<Router {...routerParams}
			>
				{/* =====================OCCUPATION CONTAINER===================== */}
				{/* ===================== SCROLL TO TOP and SUPPORT CHAT WIDGET===================== */}
				<ScrollToTop />
				<DynamicTitleComponent />
				<GlobalStyle />
				<Suspense fallback={<PageLoader />}>
					<Routes>
						<Route exact path={indexPage} element={<LandingPage />} />

						<Route
							exact
							path={insuranceLandingPage}
							element={<InsuranceComponent />}
						/>

						<Route
							exact
							path={getPrescriberPreferencesRoutePattern}
							element={<PrescriberPreferences />}
						/>
						<Route
							exact
							path={getPurchaseWebsitePackageRoutePattern}
							element={<PurchaseWebsitePackage />} />
						<Route
							exact
							path={insuranceLandingPageOld}
							element={<InsuranceComponent />}
						/>
						<Route
							exact
							path={insuranceThankyouPage}
							element={<InsuranceThankyou />}
						/>
						<Route
							exact
							path={getAvailabilityClientPattern}
							element={<AvailableClient />}
						/>
						<Route
							exact
							path={getClientTimePattern}
							element={<ClientTime />}
						/>
						<Route
							exact
							path={getClientFlexibleHoursPattern}
							element={<ClinetFliexibleHours />}
						/>
						<Route
							exact
							path={getOnboardingTimeAddServicePattern}
							element={<OnboardingTimeAddService />}
						/>
						{/* <Route
				exact
				path={clientBookingPage}
				element={<ClientBooking/>}
			/> */}
						{/* <Route
				exact
				path={mainClientPage}
				element={<MainClientPage/>}
			/> */}
						{/* <Route
				exact
				path={treatmentListing}
				element={<TreatmentListing/>}
			/> */}

						<Route
							exact
							path={bookingsCoreRoutePattern}
							Component={() => {
								window.location.href = webBaseUrl + "/clinics";
							}}
						/>

						<Route
							exact
							path={clinicCart}
							element={<BookingLink />}
						/>

						<Route
							exact
							path={clinicCartStatus}
							element={<SuccessPage />}
						/>
						{/* <Route element={<Authorization />}> */}
						<Route
							exact
							path={businessDashboardRoutePattern}
							element={<BusinessDashboard />}
						/>
						{/* </Route> */}

						<Route
							exact
							path={getStartedRoutePattern}
							element={<GetStarted />}
						/>

						<Route
							exact
							path={verifiedBannerRoutePattern}
							element={<VerifiedBannerScreen />}
						/>

						<Route
							exact
							path={getAppointmentRoutePattern}
							element={<Appointment />}
						/>
						<Route
							exact
							path={getAppointmentListRoutePattern}
							element={<AppointmentListing />}
						/>

						<Route exact path={createWebsite} element={<CreateWebsite />} />
						<Route
							exact
							path={getFacesAiAssistantRoute}
							element={<FacesAiAssistant />}
						/>
						<Route
							exact
							path={socialMediaMarketingPage}
							element={<SocialMediaMarketingLanding />}
						/>
						<Route
							exact
							path={stripePaymentPage}
							element={<StripePaymentPage />}
						/>
						<Route
							exact
							path={accountancyServicePage}
							element={<AccountancyServicePage />}
						/>
						<Route
							exact
							path={walkInConsentRoutePattern}
							element={<WalkInConsentPage />}
						/>
						<Route
							exact
							path={EditWalkInConsentRoutePattern}
							element={<WalkInConsentPage />}
						/>
						<Route
							exact
							path={clientOverViewRoutePattern}
							element={<ClientOverViewPage />}
						/>
						<Route
							exact
							path={addFormsRoutePattern}
							element={<AddForm />}
						/>
						<Route
							exact
							path={chooseServicesRoutePattern}
							element={<ChooseServices />}
						/>
						<Route
							exact
							path={chooseLocationRoutePattern}
							element={<ChooseLocationPage />}
						/>
						<Route
							exact
							path={CalendarRoutePattern}
							element={<MainCalendarView />}
						/>
						<Route
							exact
							path={NewAppointmentRoutePattern}
							element={<NewAppointment />}
						/>
						<Route
							exact
							path={NewClientRoutePattern}
							element={<AddClient />}
						/>
						<Route
							exact
							path={getOnboardingBookingLinkPattern}
							element={<OnboardingBookingLink />}
						/>
						<Route
							exact
							path={getOnboardingOnlinePaymentPattern}
							element={<OnboardingOnlinePayment />}
						/>
						<Route
							exact
							path={SearchClientRoutePattern}
							element={<SearchClient />}
						/>
						<Route
							exact
							path={ClientProfileRoutePattern}
							element={<ClientProfile />}
						/>

						<Route
							exact
							path={BookinginvoiceRoutePattern}
							element={<Bookinginvoice />}
						/>

						<Route
							exact
							path={rebookAppointmentPattern}
							element={<RebookAppointment />}
						/>

						<Route
							exact
							path={SearchLocationRoutePattern}
							element={<SearchLocation />}
						/>

						<Route
							exact
							path={ShareBookingLinkPattern}
							element={<ShareBookingLink />}
						/>

						<Route
							exact
							path={EditClientRoutePattern}
							element={<AddClient />}
						/>
						<Route
							exact
							path={EditAppointmentRoutePattern}
							element={<NewAppointment />}
						/>
						<Route
							exact
							path={EditWalkinRoutePattern}
							element={<NewAppointment />}
						/>
						<Route
							exact
							path={getPersonalWebsiteDashboardRoute}
							element={<ReEntryDashboard />}
						/>
						<Route
							exact
							path={getWebsiteBuilderPage}
							element={<WebsiteBuilder />}
						/>
						<Route
							exact
							path={stripeAccountancyPaymentPage}
							element={<AccountancyStripePaymentPage />}
						/>

						<Route
							exact
							path={getNurseInsurancetwoPricingLandingRoute}
							element={<NurseInsurancePricingTwoLanding />}
						/>

						<Route
							exact
							path={getFinanceIdentityRoute}
							element={<FinanceIdentity />}
						/>

						<Route
							exact
							path={getNurseInsurancethreePricingLandingRoute}
							element={<NurseInsurancePricingThreeLanding />}
						/>

						<Route
							exact
							path={getFinanceLandingRoute}
							element={<FinanceLanding />}
						/>

						<Route
							exact
							path={blockOutTimePattern}
							element={<BlockOutTime />}
						/>

						<Route
							exact
							path={EditBlockOutTimePattern}
							element={<BlockOutTime />}
						/>

						<Route
							exact
							path={viewBlockoutTimeRoutePattern}
							element={<BlockOutTimeView />}
						/>

					<Route
						exact
						path={getAcountancyLandingPageRoute}
						element={<AcountancyLandingPage />} />
					<Route
						exact
						path={BookingInvoiceDownloadRoutePattern}
						element={<DownloadInvoice />}
					/>
					<Route
						exact
						path={ViewClienProfileRoutePattern}
						element={<ViewClientProfile />}
					/>
					<Route
						exact
						path={getFindAPrescriberLandingPageRoute}
						element={<FindAPrescriberLandingPage />}
					/>
					<Route
						exact
						path={ClientProfileFormsRoutePattern}
						element={<FormsClient />}
					/>
					<Route
						exact
						path={ClientMedicalFormRoutePattern}
						element={<MedicalForm />}
					/>

					<Route 
						exact
						path={ClientForWardMedicalFormRoutePattern}
						element={<MedicalForm />}
					/>

					<Route 
						exact
						path={downloadMedicalFormPdfPattern}
						element={<DownloadMedicalForm/>}
					/>

						{/* <Route
				exact
				path={appointmentOverviewBeforeAndAfterPhotosRoutePattern}
				element={<BeforeAndAfterPhotosTreatment />}
			/> */}


						<Route
							exact
							path={manageFormsRoutePattern}
							element={<MainManageForm />}
						/>

						<Route
							exact
							path={createNewFormRoutePattern}
							element={<CreateNewForm />}
						/>

						<Route
							exact
							path="/edit-form/:consentId"
							element={<EditConsentForm />}
						/>

						<Route
							exact
							path="/preview-form/:consentId"
							element={<PreviewConsentForm />}
						/>

						{/* <Route
				exact
				path="/preview-form/:consentId"
				element={<PreviewConsentForm />}
			/> */}


						<Route
							exact
							path={takePaymentRoutePattern}
							element={<TakePaymentStep1 />}
						/>

						<Route
							exact
							path={getPaymentPreviewRoutePattern}
							element={<PaymentPreviewPage />}
						/>

						<Route
							exact
							path={productDetailsRoutePattern}
							element={<ProductDetails />}
						/>

						<Route
							exact
							path={appointmentPhotosRoutePattern}
							element={<BeforeAndAfterPhotos />}
						/>

						<Route
							exact
							path={onBoardingPagesRoutePattern}
							element={<OnBoardingMain />}
						/>

						<Route
							exact
							path={onBoardingLocationsRoutePattern}
							element={<LocationOnBoarding />}
						/>

						<Route
							exact
							path={completeonBoardingRoutePattern}
							element={<CompleteOnBoardingProfile />}
						/>
						<Route
							exact
							path={afterCareDashboardRoutePattern}
							element={<AfterCareDashboard />}
						/>
						<Route
							exact
							path={editAftercareFormRoutePath}
							element={<EditAfterCareForm />}
						/>

						<Route
							exact
							path={clientForwardConsetFormRoutePattern}
							element={<ClientForwConsentForm />}
						/>
						<Route
							exact
							path={completeClientForwardConsetFormRoutePattern}
							element={<ClientConsentFormPrew />}
						/>

						<Route
							exact
							path={addNewClinicRoutePattern}
							element={<AddNewClinicList />}
						/>
						<Route
							exact
							path={addNameAndAddressRoutePattern}
							element={<AddNameAndAddr />}
						/>
						<Route
							exact
							path={completeAddNewClinicRoutePattern}
							element={<CompleteClinicAddress />}
						/>
						<Route
							exact
							path={addDescriptionForNewClinicRoutePattern}
							element={<AddDescription />}
						/>
						<Route
							exact
							path={clinicContactDetailsRoutePattern}
							element={<ClinicContactDetails />}
						/>
						<Route
							exact
							path={clinicPhotoUploadRoutePattern}
							element={<UploadPhotoForNewClinic />}
						/>
						<Route
							exact
							path={clinicWorkingHoursRoutePattern}
							element={<ClinicTimeTypes />}
						/>
						<Route
							exact
							path={clinicFixTimeRoutePattern}
							element={<ClinicFixedTiminig />}
						/>
						<Route
							exact
							path={clinicQandARoutePattern}
							element={<ConsentFormQA />}
						/>
						<Route
							exact
							path={clinicFirstQandARoutePattern}
							element={<ConsentFormQA />}
						/>

						<Route
							exact
							path={createNewAfterCareFormRoutePattern}
							element={<CreateAfterCareForm />}
						/>
						<Route
							exact
							path="/prew-after-care-form/:aftercareDocId"
							element={<PrewAfterCareForm />}
						/>

						<Route
							exact
							path="/edit-after-care-form/:aftercareDocId"
							element={<EditUserAfterCareFormTemplate />}
						/>

						<Route
							exact
							path={getOnboardingAddLocationRoutePattern}
							element={<OnBoardingAddLocation />}
						/>

						<Route
							exact
							path={appointmentOverviewTakePaymentRoutePattern}
							element={<TakePayment />}
						/>

						<Route
							exact
							path={appointmentOverviewNoShowRoutePattern}
							element={<NoShow />}
						/>

						<Route
							exact
							path={appointmentOverviewBeforeAndAfterPhotosRoutePattern}
							element={<BeforeAndAfterPhotosTreatment />}
						/>

						<Route
							exact
							path={appointmentOverviewBeforeAndAfterAddPhotosRoutePattern}
							element={<BeforeAfterAddPhotos />}
						/>

						<Route
							exact
							path={appointmentOverviewBatchNumberRoutePattern}
							element={<BatchNumberSelectService />}
						/>
						<Route
							exact
							path={getOnboardingAddLocationRoutePattern}
							element={<OnBoardingAddLocation />}
						/>

						<Route
							exact
							path={appointmentOverviewTakePaymentRoutePattern}
							element={<TakePayment />}
						/>

						<Route
							exact
							path={appointmentOverviewNoShowRoutePattern}
							element={<NoShow />}
						/>

						<Route
							exact
							path={getPrescriberRegistrationRoute}
							element={<PrescriberRegistration />}
						/>
						<Route
							exact
							path={getPrescriberLandingRoute}
							element={<PrescriberLandingPage />}
						/>

						<Route exact
							path={getThankyouPageRoute}
							element={<ThankyouPage />}
						/>
						<Route exact
							path={getshopSettingRoute}
							element={<ShopSettings />}
						/>
						<Route
							exact
							path={getFinanceTrainingCertificateRoute}
							element={<FinanceTrainingCertificate />}
						/>

						<Route
							exact
							path={getCustomBuildThankYouRoutePattern}
							element={<WelcomeScreenThankYou />}
						/>
						<Route
							exact
							path={getFinanceInsuranceRoute}
							element={<FinanceInsurance />}
						/>

						<Route
							exact
							path={getForwardConsentFormPageRoute}
							element={<ForwardConsentForm />}
						/>

						<Route
							exact
							path={getThankyouPageRoute}
							element={<ThankyouPage />}
						/>

						<Route
							exact
							path={getForwardConsentFormStatus}
							element={<SuccessForwardConsentForm />}
						/>

						<Route
							exact
							path={getFinanceGetPaidRoute}
							element={<FinanceGetPaid />}
						/>

						<Route
							exact
							path={getFinanceRegistrationRoute}
							element={<FinanceRegistration />}
						/>

						<Route
							exact
							path={getPrescriberAboutYouRoute}
							element={<PrescriberAboutYou />}
						/>

						<Route
							exact
							path={getPrescriberBusinessDetailsRoute}
							element={<PrescriberBusinessDetails />}
						/>
						<Route
							exact
							path={getFinancetermsRoute}
							element={<FinanceTemsAndCondition />}
						/>

						<Route
							exact
							path={HairProductLinkRoutePattern}
							element={<HairProductLink />}
						/>

						<Route
							exact
							path={HairProductsRoutePattern}
							element={<HairProducts />}
						/>

						<Route
							exact
							path={HairPrescriptionProductsRoutePattern}
							element={<HairProducts />}
						/>


						<Route
							exact
							path={HairProductsAmendAnswersRoutePattern}
							element={<HairPrescriptionAmendAnswers />}
						/>


						<Route
							exact
							path={registrationLandingPage}
							element={<RegistrationComponent />}
						/>
						<Route
							exact
							path={loginLandingPage}
							element={<LoginComponent />}
						/>
						<Route
							exact
							path={revenueDashboardLandingPage}
							element={<RevenueDashboardComponent />}
						/>
						<Route
							exact
							path={verifyEmailLandingPage}
							element={<VerifyEmailComponent />}
						/>
						<Route
							exact
							path={forgotEmailLandingPage}
							element={<ForgotEmailComponent />}
						/>
						<Route
							exact
							path={verifyForgotPasswordLandingPage}
							element={<VerifyForgotPasswordComponent />}
						/>
						<Route
							exact
							path={forgotEmailUpdateLandingPage}
							element={<ForgotPasswordUpdateComponent />}
						/>
						<Route
							exact
							path={editProfileLandingPage}
							element={<EditProfileComponent />}
						/>
						<Route
							exact
							path={comingSoon}
							element={<ComingSoon />}
						/>
						<Route
							exact
							path={getSMSBalanceRoute}
							element={<Purchasesmsplan />}
						/>


						<Route
							exact
							path={financeFirstStapPage}
							element={<FinanceFirstStapPage />}
						/>
						<Route
							exact
							path={downloadFinanceInvoicePage}
							element={<DownloadFinanceInvoice />}
						/>
						<Route
							exact
							path={noFinanceRequests}
							element={<NoFinanceRequestsPage />}
						/>
						<Route
							exact
							path={financeOnboardingSteps}
							element={<FinanceOnboardingSteps />}
						/>
						<Route
							exact
							path={welcomeBack}
							element={<WelcomeBack />}
						/>
						<Route
							exact
							path={financeStepsThankYouPage}
							element={<FinanceStepsThankYouPage />}
						/>
						<Route
							exact
							path={financeStepsAbortPage}
							element={<FinanceStepsAbortPage />}
						/>
						<Route
							exact
							path={financeStepsFailPage}
							element={<FinanceStepsFailPage />}
						/>
						<Route
							exact
							path={financeOnboardingStepsNewDesign}
							element={<FinanceOnboardingStepsNew />}
						/>
						{/* <Route
				exact
				path={getAcountancyLandingPageRoute}
				element={<AcountancyLandingPage />}
			/> */}
						<Route
							exact
							path={initiateFinanceLoanRequest}
							element={<InitiateFinanceLoanRequest />}
						/>

						<Route
							exact
							path={getRyftOnboardingPageRoute}
							element={<RyftOnboarding />}
						/>

						{/* <Route
							exact
							path={hairCareLandingPageRouteRequest}
							element={<HairCareLandingPage />}
						/> */}
						<Route
							exact
							path={clientAdditionalPhotos}
							element={<ClientAdditionalPhotos />}
						/>

						<Route
							exact
							path={businessSettingRoute}
							element={<BusinessProfileSetting />}
						/>
						<Route
							exact
							path={businesslocationRoutePattern}
							element={<BusinessLocation />}
						/>
						<Route
							exact
							path={businessLocationDetailsRoutePattern}
							element={<BusinessLocationDetails />}
						/>
						<Route
							exact
							path={businessTreatmentDetailsRoutePattern}
							element={<BusinessTreatmentDetails />}
						/>
						<Route
							exact
							path={businessTransactionListRoutePattern}
							element={<TransactionList />}
						/>

						<Route
							exact
							path={businessTransactionDetailsRoutePattern}
							element={<TransactionDetails />}
						/>


						<Route
							exact
							path={editMedicalFormRoute}
							element={<EditMedicalForm />}
						/>
						<Route
							exact
							path={previewMedicalFormRoute}
							element={<PreviewMedicalForm />}
						/>
						<Route
							exact
							path={businessTreatmentRoutePattern}
							element={<BusinessTreatment />}
						/>
						<Route
							exact
							path={addBusinessTreatmentRoutePattern}
							element={<BusinessTreatmentDetails />}
						/>
						<Route
							exact
							path={appointmentOverviewAppTakePaymentRoutePattern}
							element={<AppAddCardPage />}
						/>
						<Route
							exact
							path={TreatmentCategoriesRoutePattern}
							element={<TreatmentCategories />}
						/>
						<Route
							exact
							path={preOnboardingSelectIndustryPath}
							element={<POSelectIndustry />}
						/>
						<Route
							exact
							path={preOnboardingBusinessDetailsPath}
							element={<POBusinessDetails />}
						/>
						<Route
							exact
							path={preOnboardingBusinessPurposePath}
							element={<POBusinessPurpose />}
						/>
						<Route
							exact
							path={preOnboardingBusinessSizePath}
							element={<POBusinessSize />}
						/>
						<Route
							exact
							path={getForwardConsentFormStatus}
							element={<SuccessForwardConsentForm />}
						/>

						<Route
							exact
							path={getFinanceGetPaidRoute}
							element={<FinanceGetPaid />}
						/>

						<Route
							exact
							path={getFinanceRegistrationRoute}
							element={<FinanceRegistration />}
						/>

						<Route
							exact
							path={getPrescriberAboutYouRoute}
							element={<PrescriberAboutYou />}
						/>

						<Route
							exact
							path={getPrescriberBusinessDetailsRoute}
							element={<PrescriberBusinessDetails />}
						/>
						<Route
							exact
							path={getFinancetermsRoute}
							element={<FinanceTemsAndCondition />}
						/>

						<Route
							exact
							path={HairProductLinkRoutePattern}
							element={<HairProductLink />}
						/>

						<Route
							exact
							path={HairProductsRoutePattern}
							element={<HairProducts />}
						/>

						<Route
							exact
							path={HairPrescriptionProductsRoutePattern}
							element={<HairProducts />}
						/>


						<Route
							exact
							path={HairProductsAmendAnswersRoutePattern}
							element={<HairPrescriptionAmendAnswers />}
						/>


						<Route
							exact
							path={registrationLandingPage}
							element={<RegistrationComponent />}
						/>
						<Route
							exact
							path={loginLandingPage}
							element={<LoginComponent />}
						/>
						<Route
							exact
							path={revenueDashboardLandingPage}
							element={<RevenueDashboardComponent />}
						/>
						<Route
							exact
							path={verifyEmailLandingPage}
							element={<VerifyEmailComponent />}
						/>
						<Route
							exact
							path={forgotEmailLandingPage}
							element={<ForgotEmailComponent />}
						/>
						<Route
							exact
							path={verifyForgotPasswordLandingPage}
							element={<VerifyForgotPasswordComponent />}
						/>
						<Route
							exact
							path={forgotEmailUpdateLandingPage}
							element={<ForgotPasswordUpdateComponent />}
						/>
						<Route
							exact
							path={editProfileLandingPage}
							element={<EditProfileComponent />}
						/>
						<Route
							exact
							path={financeFirstStapPage}
							element={<FinanceFirstStapPage />}
						/>
						<Route
							exact
							path={downloadFinanceInvoicePage}
							element={<DownloadFinanceInvoice />}
						/>
						<Route
							exact
							path={noFinanceRequests}
							element={<NoFinanceRequestsPage />}
						/>
						<Route
							exact
							path={financeOnboardingSteps}
							element={<FinanceOnboardingSteps />}
						/>
						<Route
							exact
							path={welcomeBack}
							element={<WelcomeBack />}
						/>
						<Route
							exact
							path={financeStepsThankYouPage}
							element={<FinanceStepsThankYouPage />}
						/>
						<Route
							exact
							path={ThankyouPageRoute}
							element={<ThankyouPharmacy />}
						/>
						<Route
							exact
							path={PharmacyPrefrencesRoute}
							element={<PrescribingPrefrence />}
						/>
						<Route
							exact
							path={financeStepsAbortPage}
							element={<FinanceStepsAbortPage />}
						/>
						<Route
							exact
							path={financeStepsFailPage}
							element={<FinanceStepsFailPage />}
						/>
						<Route
							exact
							path={financeOnboardingStepsNewDesign}
							element={<FinanceOnboardingStepsNew />}
						/>
						{/* <Route
							exact
							path={getAcountancyLandingPageRoute}
							element={<AcountancyLandingPage />}
						/> */}
						<Route
							exact
							path={initiateFinanceLoanRequest}
							element={<InitiateFinanceLoanRequest />}
						/>

						{/* <Route
							exact
							path={hairCareLandingPageRouteRequest}
							element={<HairCareLandingPage />}
						/> */}
						<Route
							exact
							path={clientAdditionalPhotos}
							element={<ClientAdditionalPhotos />}
						/>

						<Route
							exact
							path={getBusinessProfileSettingPageRoute}
							element={<BusinessProfileSetting />}
						/>

						<Route
							exact
							path={getBusinessProfileMarketingPageRoute}
							element={<Marketing />}
						/>
						{/* <Route
							exact
							path={getSettingPageRoute}
							element={<BusinessSetting />}
						/> */}

					<Route
						exact
						path={getNoclientPageRoute}
						element={<NoClient />}
					/>
					<Route
						exact
						path={getBusinessSettingPageRoute}
						element={<BusinessSetting />}
					/>
					<Route
						exact
						path={getManageAccountPageRoute}
						element={<ManageAccount />}
					/>
					<Route
						exact
						path={getPaymentsControlPageRoute}
						element={<PaymentsControl />}
					/>
					<Route
						exact
						path={getFormSettingsPageRoute}
						element={<Form />}
					/>
					<Route
						exact
						path={getSecuritySettingsPageRoute}
						element={<Security />}
					/>
					<Route
						exact
						path={editMedicalFormRoute}
						element={<EditMedicalForm />}
					/>
					<Route
						exact
						path={previewMedicalFormRoute}
						element={<PreviewMedicalForm />}
					/>
					<Route
						exact
						path={getImportClient}
						element={<ImportClient />}
					/>

              <Route 
            	exact
            	path={productQuestionsRoute}
            	element={<ProductQuestions/>}
          	  />
			  <Route 
                exact
                path={productQuestionAnswerRoute}
                element={<PrductQuestionAnswer/>}
             /> 

			
					<Route
						exact
						path={getCompanyRyftOnboardingPageRoute}
						element={<CompanyRyftOnboarding />}
					/>
					<Route
						exact
						path={duplicateFormRoutePattern}
						element={<NewAppointment />}
					/>
					<Route
						exact
						path={getPrescriptionServicesPageRoute}
						element={<PrescriptionServices />}
					/>
					<Route
						exact
						path={getMyStockistsPageRoute}
						element={<MyStockists />}
					/>

						<Route
							exact
							path={getPrescriberBioPageRoute}
							element={<PrescriberBio />}
						/>
						
						<Route
							exact
							path={businessSupport}
							element={<BusinessSupport />}
						/>
						<Route
							exact
							path={getSMSRoute}
							element={<SendTextSms />}
						/>

						<Route
							exact
							path={getEmailRoute}
							element={<EmailsTemplate />}
						/>

						<Route
							exact
							path={getPrescriberListPageRoute}
							element={<PrescriberList />}
						/>

						<Route
							exact
							path={getPrescriberDetailsPageRoute}
							element={<PrescriberProfileDetails />}
						/>

						<Route
							exact
							path={getCreatePrescriptionPageRoute}
							element={<CreatePrescription />}
						/>

						<Route
							exact
							path={getFacesSupportRoute}
							element={<GetFacesSupport />}
						/>    

						<Route
							exact
							path={getYourOrdersRoute}
							element={<YourOrders />}
						/>    

						<Route
							exact
							path={getExecutiveSupportRoute}
							element={<ExecutiveSupport />}
						/>    

						<Route
							exact
							path={getTicketsRoute}
							element={<Tickets />}
						/> 

						<Route
							exact
							path={getKnowledgeBaseRoute}
							element={<KnowledgeBase />}
						/> 

						<Route
							exact
							path={getCategoryDetailsRoute}
							element={<CategoryDetails />}
						/>

					<Route
						exact
						path={getChatRoute}
						element={<Chat />}
					/> 
					<Route
						exact
						path={downloadConsentFormPattern}
						element={<DownloadConsentForm />}
					/>
					<Route
						exact
						path={getNotificationRoute}
						element={<Notification />}
					/>

					<Route
						exact
						path={businessTreatmentCategoriesRoutePattern}
						element={<BusinessTreatmentcategories />}
					/>

					</Routes>
				</Suspense>
			</Router>

			<ToastContainer
				position="top-left"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme="dark"
			/>

		</>

	);
}

export default App;